import type { PropertyPaneControlConfig } from "legacy/constants/PropertyControlConstants";

export function getPropertyName(
  item: {
    originalItemId?: PropertyPaneControlConfig["originalItemId"];
    propertyName: PropertyPaneControlConfig["propertyName"];
  },
  itemProperties: Record<string, unknown>,
): string {
  return typeof item.propertyName === "function"
    ? item.propertyName(itemProperties, {
        originalItemId: item.originalItemId,
      })
    : item.propertyName;
}
